import { useEffect, useRef, useState } from 'react';

function Reveal({ children, delay = 0, className = '', as: Tag = 'div', style = {} }) {
  const ref  = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          obs.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`sc-reveal${show ? ' sc-visible' : ''} ${className}`}
      style={{ '--delay': `${delay}ms`, ...style }}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
